export default function Company() {
  return <h1>Company</h1>;
}
